// extracted by mini-css-extract-plugin
export var statItem = "_cl-1";
export var statsRow = "_cl-0";